export function shortenAddress(
  address: string,
  afterDotLength?: number,
  beforeDotLength?: number,
) {
  if (!address) return "";
  if (beforeDotLength && afterDotLength) {
    return `${address.slice(0, beforeDotLength)}...${address.slice(
      -afterDotLength,
    )}`;
  }
  if (beforeDotLength) {
    return `${address.slice(0, beforeDotLength)}...${address.slice(-5)}`;
  }
  if (afterDotLength) {
    return `${address.slice(0, 6)}...${address.slice(-afterDotLength)}`;
  }
  return `${address.slice(0, 6)}...${address.slice(-5)}`;
}
